import { http } from "../client";
export var playDevice = function (id) { return http.api.post("devices/" + id + "/play"); };
